export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5379.ee360a5d.jpg";